import Tool, { type IToolAvailableInput } from './Tool';

class ToolClearReactions extends Tool {
  static toolName = 'Clear reactions';

  static action({ controller, selection }) {
    selection.forEach(obj => {
      obj.set('reactions', null);
    });
    this.toolActionComplete({ controller });
  }

  static enabled({ selection }) {
    if (!selection) return false;

    let hasReactions = false;
    selection.forEach(obj => {
      hasReactions ||= obj.reactions && Object.keys(obj.reactions).length;
    });
    return hasReactions;
  }

  static available({ selection }: IToolAvailableInput) {
    return this.enabled({ selection });
  }
}

export default ToolClearReactions;
